var routes = {

  AUTHENTICATION: {
    CHANGE_PASSWORD: '/app/api/clients/changePassword',
    RECOVER_PASSWORD: '/app/api/clients/sendPasswordRecoverToken',
    DO_RECOVER_PASSWORD: '/app/api/clients/recoverPassword',
    CREATE_AND_LOGIN: '/app/api/clients/createAndLogin',
    REGISTER_AND_CHECKIN: '/app/api/registration/finishRegistration',
    CHECK_IS_REGISTERED: '/app/api/clients/checkIsRegistered',
    DO_LOGIN: '/app/api/clients/login',
    CHECK_USER: '/app/api/clients/checkUser',
    CHECK_LOGIN: '/app/api/clients/checkLogin',
    SEND_CONFIRMATION_CODE: '/app/api/registration/startRegistration',
    CHECK_CONFIRMATION_CODE: '/app/api/clients/checkConfirmation',
    SHOULD_REDIRECT: '/app/api/shouldRedirect'
  },

  REVIEWS: {
    SUBMIT_REVIEW: '/app/api/reviews/new',
    GET_STORE_INFO: '/app/api/reviews/getReviewData',
    GET_HIGHEST_STORE_SCORE: '/app/api/reviews/getHighestStore',
    GET_ALL_REVIEWS: '/app/api/reviews/get',
    GET_STORE_SAMPLE: '/app/api/reviews/getStoreSample',
    GET_MORE_STORE_REVIEWS: '/app/api/reviews/getMoreStoreReviews',
    GET_EMPLOYEE_SAMPLE: '/app/api/reviews/getEmployeeSample',
    GET_MORE_EMPLOYEE_REVIEWS: '/app/api/reviews/getMoreReviews',
    GET_REVIEWS_ALL: '/app/api/reviews/getReviewsAll',
    GET_EMPLOYEE_ALL: '/app/api/reviews/getEmployeeAll',
    GET_PROVIDERS: '/app/api/static/serviceProviders',
    GET_SINGLE_REVIEW: '/app/api/reviews/getSingleReview',
    NEW_REPLY: '/app/api/reviews/newReply',
    EDIT_REPLY: '/app/api/reviews/editReply',
    DELETE_REPLY: '/app/api/reviews/deleteReply',
    UPLOAD_PHOTO: '/app/api/photos/upload'
  },


  BOOKING: {
    SUMMARY: '/app/api/booking/bookingSummary',
    WAIT_LIST_SUMMARY: '/app/api/booking/waitListSummary',
    CONFIRM: '/app/api/booking/confirm',
    GET_ALTERNATIVES: '/app/api/booking/getAlternatives',
    START_BOOKING: '/app/api/booking/startBooking',
    BOOK_APPOINTMENT: '/app/api/booking/bookAppointment',
    BOOK_WAIT_LIST: '/app/api/booking/bookWaitList',
    CHECK_IN_LATER: '/app/api/booking/checkinLater',
    CHECK_IN_LATER_TIMESPANS: '/app/api/booking/checkinLaterAvailableTimespans',
    WAIT_LIST_CHECK: '/app/api/booking/checkWaitList',
    SEARCH: '/app/api/booking/search',
    SINGLE_STORE_SEARCH: '/app/api/booking/singleStoreSearch',
    WAIT_LIST_SEARCH: '/app/api/booking/waitListSearch',
    GET_SINGLE_STORE_INFO: '/app/api/booking/getSingleStoreGroupInfo',
    CANCEL_APPOINTMENT: '/app/api/booking/cancel',
    CANCEL_WAIT_LIST: '/app/api/booking/cancelWaitList',
    GET_CONFIRM_CLIENT: '/app/api/booking/getConfirmClient',
    GET_UPCOMING_APPOINTMENTS: '/app/api/clients/upcomingAppointments',
    GET_WAIT_LIST: '/app/api/clients/waitingList',
    GET_WAIT_BOARD: '/app/api/clients/waitBoard',
    GET_CARD_IFRAME_URL: '/app/api/payments/cardFrameUrl',
    GET_STORE_SCHEDULES: '/app/api/static/storeSchedules',
    GET_SERVICE_PROVIDERS: '/app/api/static/serviceProviders',
    GET_GUEST_WAIT_LIST: '/app/api/clients/guestWaitingList',
    GET_GEO_IP: '/app/api/location/iplocate',
    PUBLIC_WAIT_BOARD: '/app/api/stores/getWaitBoard'
  },

  CLIENT: {
    SERVICE_HISTORY: '/app/api/clients/serviceHistory',
    RECENT_APPOINTMENTS: '/app/api/clients/recentPastAppointments',
    PROFILE_UPDATE: '/app/api/clients/updateProfile',
    OPT_IN_UPDATE: '/app/api/clients/updateOptIn',
    MARKET_OPT_IN_UPDATE: '/app/api/clients/updateMarketingOptIn',
    REVIEWS_HISTORY: '/app/api/clients/getClientReviews',
    REVIEW_GET: '/app/api/clients/getClientReview',
    REVIEW_UPDATE: '/app/api/clients/updateClientReview'
  },

  EMPLOYEE_REVIEWS: {
    GET_ALL: '/app/api/employee-reviews/getAll',
    GET_SAMPLE: '/app/api/employee-reviews/getSample',
    GET_PROVIDERS: '/app/api/static/serviceProviders'
  },

  SEARCH: {
    LOCATION_FIND: '/app/api/location/find',
    //SEARCH_NEAREST_OPEN_STORES: '/app/api/stores/findNearWithTimes',
    SEARCH_NEAREST_OPEN_STORES: '/app/api/stores/findNear',
    GET_STORE_WAIT_TIMES: '/app/api/stores/getWaitTimes',
    GET_STORE_LOCATION: '/app/api/stores/getCoordinatesByStore',
    GEO_AUTOCOMPLETE: '/app/api/location/geoAutocomplete'
  },

  GIFT_CARDS: {
    GET_TEMPLATES: '/app/api/gift-cards/getGiftCardTemplates',
    CREATE_OR_UPDATE: '/app/api/gift-cards/createOrUpdateGiftCard',
    SEND_TO_SU: '/app/api/gift-cards/synchGifCardWithSU'
  },

  CARDS: {
    GET_PAYMENT_URL: '/app/api/payments/paymentFrameUrl'
  },

  STORES: {
    FIND_BY_ZIP: '/app/api/stores/findByZip',
  }

};

module.exports = routes;
